import { RADIUS, SHADOW } from '../styles/brandTokens';

export const ticketAnalysisTableSurfaceStyles = {
  bgcolor: 'background.paper',
  border: '1px solid',
  borderColor: 'divider',
  borderRadius: `${RADIUS.card}px`,
  boxShadow: SHADOW.card,
};

export const ticketAnalysisTableStyles = {
  ...ticketAnalysisTableSurfaceStyles,
  '& td.MuiTableCell-alignRight > .MuiButton-root': {
    textAlign: 'right',
    justifyContent: 'flex-end',
    minWidth: 0,
    px: 0,
    fontVariantNumeric: 'tabular-nums',
  },
  '& tbody tr': { transition: 'background-color 150ms ease, box-shadow 150ms ease' },
  '& tbody tr:hover, & tbody tr:has(:focus-visible), & tbody tr.Mui-selected': {
    bgcolor: 'action.hover',
    boxShadow: SHADOW.cardHover,
  },
  '& tbody tr.Mui-selected:hover': { bgcolor: 'action.selected' },
  '@media (prefers-reduced-motion: reduce)': { '& tbody tr': { transition: 'none' } },
};
